/**
 * Normalizes dropdownAppend to { left: [], right: [] }.
 * Supports:
 * - Legacy: { position: "left"|"right", component|icon, props, classes, ... }
 * - New:    { left: [...], right: [...] }
 */
export function normalizeDropdownAppends(dropdownAppend) {
  if (!dropdownAppend) return { left: [], right: [] }

  if (Array.isArray(dropdownAppend.left) || Array.isArray(dropdownAppend.right)) {
    return {
      left: dropdownAppend.left || [],
      right: dropdownAppend.right || [],
    }
  }

  const { position, ...item } = dropdownAppend
  if (position === "left") return { left: [item], right: [] }
  if (position === "right") return { left: [], right: [item] }
  return { left: [], right: [] }
}

export function hasLeftDropdownAppend(dropdownAppend) {
  const { left } = normalizeDropdownAppends(dropdownAppend)
  return left.some(item => item?.component || item?.icon)
}

export function hasDropdownAppendContent(dropdownAppend) {
  const { left, right } = normalizeDropdownAppends(dropdownAppend)
  return [...left, ...right].some(item => item?.component || item?.icon)
}

export function hasLeftDropdownAppendSlot(dropdownAppend) {
  return normalizeDropdownAppends(dropdownAppend).left.length > 0
}
